module.exports = __webpack_public_path__ + "img/风险预测.be8a9020.png";